module.exports = __webpack_public_path__ + "static/media/logo.e908a029.png";